import { FC } from "react"
import './precipitacion.css'
import { PrecipitacionMap } from "./PrecipitacionMap/PrecipitacionMap"
import { PrecipitacionTable } from "./PrecipitacionTable/PrecipitacionTable"
import { PrecipitacionTableSimple } from "./PrecipitacionTable/PrecipitacionTableSimple"

export const Precipitacion:FC<any> = (props):JSX.Element => {

    const { data, setData, dataMASTER, simulated,original, comparativa, saveLoading, same, scenarioBase } = props
    
    return (
        <div className="precipitacion__wrapper">
            <PrecipitacionMap mapData={data?.precipitation_map?.filter((md:any) => md.latitude !== null && md.longitude !== null)} />
            {
                comparativa?
                    <PrecipitacionTable
                        scenarioBase={scenarioBase}
                        data={data}
                        setData={setData}
                        dataMASTER={dataMASTER}
                        simulated={simulated}
                        original={original}
                        saveLoading={saveLoading}
                        same={same}
                    />
                :
                    <PrecipitacionTableSimple
                        scenarioBase={scenarioBase}
                        data={data}
                        setData={setData}
                        dataMASTER={dataMASTER}
                        simulated={simulated}
                        original={original}
                        saveLoading={saveLoading}
                    />
            }
            
        </div>
    )
}